// extracted by mini-css-extract-plugin
export var downArrow = "_ac-0";
export var label = "_ac-1";
export var treatmentCard = "_ac-3";
export var upArrow = "_ac-2";